<template>
    <div class="indent">
        <div class="banner">
        </div>
        <div class="wrapper">
            <div style="text-align:center;font-weight:bold;font-size:20px">版权及免责声明</div>
            <div>

徐州乐分享软件科技有限公司（以下简称“乐分享软件”）提供的乐分享题库、组卷和考试系列产品（以下简称“本软件”），系列产品包括乐分享云题库、乐分享题库网页端、乐分享题库电脑客户端、乐分享考试网页端、乐考试移动端。使用本软件前请您仔细阅读以下条款。使用本软件则表明您已明确理解并接受这些条款。如果不接受这些条款请不要使用本软件。
            </div>
<div class="title">
1. 关于本软件的会员

</div>
<div>

1．1 您在本软件上传您原创的资料，即表示您同意本软件和您共同拥有此资料的版权（私有题目的版权只属于上传者所有，我们会为用户严格保密）。
</div>
<div>
1．2 您在本软件上传您转载的资料，请注意一定要得到原作者的同意或授权；如果是通过其他网站转载，请注意该网站的版权声明，得到授权后方可上传资料。否则一切后果自负。对于用户发布的内容所引发的版权、署名权的异议、纠纷不承担任何责任。

</div>
<div>

1．3 您在本站发表的所有信息和资料必须遵守中华人民共和国的相关法律法规，若有违规行为，责任自负。
</div>
<div>

1．4 作为本软件的会员，您有下载、使用本软件资料的权利。这里的使用指个人的、非商业性的使用。任何公开性质的、或商业性的使用，必须征得本软件或原作者的同意，或直接取得原作者的授权。
</div>
<div>

1．5 作为本软件的会员，经本软件或原创作者同意后，您可以根据需要对本软件内容进行转载，但必须注明出处，即有“转载自乐分享题库”字样；如需用于商业，必须支付相应的费用，具体费用可协商解决。否则视为侵权行为，承担法律责任。
</div>
<div class="title">

2．关于本软件
</div>
<div>
2．1 您在本软件上传您原创的资料，本软件将保护您的合法权益。

</div>
<div>

2．2 您在本软件上传您原创的资料，即表示您同意本软件有优先集结、使用您原创的资料的权利，包括商业性的使用。本软件将通过点数的方式，通过提供优质的共享资料和其他服务付费。（私有题目除外。对于私有题目，我们不会做任何处理！私有题目仅由上传者（机构）自己处理！）
</div>
<div>

2．3 若您认为本软件会员上传的某些资料侵犯了您个人或网站的权利，请您与本软件联系，并提供以下材料，本软件工作人员将及时处理：
</div>
<div>

2.3.1 真实有效的身份证明文件。
</div>
<div>

包括但不限于公司企业营业执照复印件（加盖公司公章）、身份证复印件等。
</div>
<div>

2.3.2 真实有效的权利证明文件。
</div>
<div>

包括但不限于能够证明您确实享有著作权或相关权利的著作权登记证明材料、作品创作合同等。
</div>
<div>

2.3.3 侵权情况简述材料。
</div>
<div>
如侵权作品名称、在本网站的侵权链接及ID号等。

</div>
<div>

2．4 如果您的网站正式起用了本软件中的部分内容，请您通知我们，以便我们能够知晓。如果可能，请在您的网站做上我们的链接，希望能给予合作。
</div>
<div>

2．5 本网站所载的资料、信息仅供会员参考，目的是更好地为我们的广大会员服务。我们尽力确保所有资料是准确、完整及最新的，但不保证所有资料、信息、素材、链接及其他项目绝对准确无误，请您自己鉴定。对依赖该资料所引致的任何意外本网站概不负责，亦不承担任何经济和法律责任。
</div>
<div>
2．6 未尽事宜以相关法律和论坛最新公告为准。

</div>
<div>

2．7 本软件可能修改某些条款。您应经常访问本页面以了解最新条款，因为这些条款与您密切相关。这些条款的某些条文也可能被本软件中某些页面上明确指定的通告或法律条款所取代。
</div>
<div>
请自觉遵守上述声明。凡有侵权行为的个人、法人或其它组织，必须立即停止侵 权并对其因侵权造成的一切后果承担全部责任和相应赔偿。否则我们将依据中华人民共和国相关法律、法规追究其经济和法律责任。

</div>

        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    }
}
</script>
<style lang="less">
    .indent{
        .banner{
            position: fixed;
            top: 0;
            left: 0;
            height: 60px;
            width: 100%;
            background: #198AF7;
        }
        .wrapper{
            padding-top: 80px;
            padding-bottom: 20px;
            width: 1200px;
            margin: 0 auto;
            font-size: 16px;
            line-height: 30px;
            .space2{
                text-indent: 2em;
            }
            .title{
                font-weight: bold;
                margin-top: 10px;
            }
        }
    }
</style>